// Start typing javascript code ...

const dsaGuardModeratorInit = async () => {
    const moderatorElements = document.querySelectorAll('[data-dsa-guard-moderator]');

    if (moderatorElements.length > 0) {
        const { dsaGuardModerator } = await import(
            /* webpackChunkName: 'chunk-dsaGuardModerator' */
            '@default/scripts/modules/dsa-daktela/dsaGuardModerator'
        );

        dsaGuardModerator(moderatorElements);
    }
};

Promise.all([dsaGuardModeratorInit()]).then(
    () => {
        // console.log('Všechny moduly načteny.');
    },
    () => {
        // console.log('Some modules not loaded');
    },
);
